








import Vue from "vue";
import { Component } from "vue-property-decorator";
import GlobalMessageUI from "@/components/GlobalMessage/GlobalMessageUI.vue";

@Component({
  components: {
    GlobalMessageUI,
  },
})
export default class App extends Vue {}
